// import React, { useEffect, useState } from 'react';
// import { sitePolicy } from '../asiosConfig';
// import { toast } from 'react-toastify';
// import { Box, Container, Paper, Skeleton, Typography } from '@mui/material';

// import Footer from './Footer';
// import testimonyImg from "../images/testimonyImg.png";
// import { Helmet } from 'react-helmet-async';
// import Navbar from './Navbar';


// export const AboutUs = () => {
//     const [aboutUs, setAboutUs] = useState({});
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchAboutUs = async () => {
//             try {
//                 const response = await sitePolicy();
//                 if (response.status === 200 || response.status === 201) {
//                     setAboutUs(response.data.data);
//                 } else {
//                     toast.error('Failed to fetch about us data');
//                 }
//             } catch (error) {
//                 toast.error('Failed to fetch about us data');
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAboutUs();
//     }, []);

//     return (
//         <Box>
//             <Helmet>
//                 <title>About IND Matrimony – Leading Matchmaking Platform in India</title>
//                 <meta name="description" content="Learn about IND Matrimony, India's trusted matchmaking platform. Discover our mission to connect verified profiles for meaningful relationships and happy marriages." />
//                 <meta name="keywords" content="about IND Matrimony, matchmaking platform India, verified profiles, find partner, marriage matchmaking" />
//                 <meta property="og:title" content="About IND Matrimony – Trusted Matchmaking in India" />
//                 <meta property="og:description" content="IND Matrimony connects verified profiles for lasting relationships. Learn our story and mission." />
//                 <meta property="og:image" content="%PUBLIC_URL%/indLogo.png" />
//                 <meta property="og:url" content="https://indmatrimony.in/about-us" />
//                 <meta property="og:type" content="website" />
//                 <meta name="twitter:card" content="summary_large_image" />
//                 <meta name="twitter:title" content="About IND Matrimony" />
//                 <meta name="twitter:description" content="India's leading matchmaking platform for verified profiles." />
//                 <meta name="twitter:image" content="%PUBLIC_URL%/indLogo.png" />
//                 <link rel="canonical" href="https://indmatrimony.in/about-us" />
//                 <script type="application/ld+json">
//                 {JSON.stringify({
//                     "@context": "https://schema.org",
//                     "@type": "AboutPage",
//                     "name": "About IND Matrimony",
//                     "url": "https://indmatrimony.in/about-us",
//                     "description": "About page for IND Matrimony, detailing the platform's mission and services.",
//                     "isPartOf": {
//                         "@type": "WebSite",
//                         "name": "IND Matrimony",
//                         "url": "https://indmatrimony.in"
//                     }
//                 })}
//                 </script>
//             </Helmet>
//             <Navbar />
//             <Box mt={12}>
//                 <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 } , background: "linear-gradient(180deg, #fff8f0 0%, #fff4ef 100%)",}}>
//                     <Paper elevation={4} sx={{ p: 4, mb: 6, width: '80%', mx: 'auto' }}>
//                         <Box textAlign="center" mb={12} mt={5}>
//                             {loading ? (
//                                 <>
//                                     {/* Skeleton for Title */}
//                                     <Skeleton variant="text" width="60%" height={40} sx={{ mx: 'auto', mb: 3 }} />

//                                     {/* Skeleton for Description */}
//                                     <Skeleton variant="rectangular" height={100} width="100%" sx={{ mb: 4 }} />

//                                     {/* Skeletons for Testimony Images */}
//                                     <Box display="flex" justifyContent="center" gap={2} flexWrap="wrap" mt={4}>
//                                         {[...Array(4)].map((_, index) => (
//                                             <Skeleton
//                                                 key={index}
//                                                 variant="rectangular"
//                                                 width={150}
//                                                 height={150}
//                                                 sx={{ borderRadius: 1 }}
//                                             />
//                                         ))}
//                                     </Box>
//                                 </>
//                             ) : (
//                                 <>
//                                     <Typography
//                                         variant="h4"
//                                         component="h3"
//                                         gutterBottom
//                                         sx={{ fontFamily: "Montserrat" }}
//                                     >
//                                         IND Matrimony About Us
//                                     </Typography>

//                                     <Typography
//                                         variant="h6"
//                                         component="h4"
//                                         gutterBottom
//                                         sx={{ fontFamily: "Montserrat" }}
//                                     >
//                                         Where Trust Meets Togetherness
//                                     </Typography>

//                                     <div className='text-left' dangerouslySetInnerHTML={{ __html: aboutUs.about_us }} />
                                   
//                                 </>
//                             )}
//                         </Box>
//                     </Paper>
//                 </Container>
//             </Box>
//             <Footer />
//         </Box>
//     );
// };







import AboutLayout from "./AboutLayout";
import { Box, Typography } from "@mui/material";

export const AboutUs = () => {
  return (
    <AboutLayout>
      {/* TITLE SECTION */}
      <Box textAlign="center" mb={6}>
        <Typography
          variant="h2"
          sx={{ fontFamily: "Playfair Display", fontWeight: 600 }}
        >
          About{" "}
          <Box component="span" sx={{ color: "#e65c2f" }}>
            IND Matrimony
          </Box>
        </Typography>

        <Typography mt={2} fontWeight={500}>
          Where Trust Meets Togetherness
        </Typography>
      </Box>
    </AboutLayout>
  );
};
